import {
  GET_CALIBRATION_APPLICATIONS_API,
  GET_FIRMWARE_RELEASES_API,
  GET_PROGRAMMING_APPLICATIONS_API
} from '~/constants/APIs'

import {
  FirmwareReleasesDataType,
  SupportedFeatureType,
  SupportingApplicationsData
} from '~/models'

import axiosClient from './axiosClient'

export const configurationApis = {
  getFirmwareReleases: (
    hideObsolete: boolean,
    boardTypeId: number,
    approvedFirmwareReleaseId: number
  ) =>
    axiosClient.get(GET_FIRMWARE_RELEASES_API, {
      params: { hideObsolete, boardTypeId, approvedFirmwareReleaseId }
    }) as unknown as FirmwareReleasesDataType,

  getSupportedFeatures: (firmwareId: number | null) =>
    axiosClient.get(
      `${GET_FIRMWARE_RELEASES_API}/${firmwareId}/supportedfeatures`
    ) as unknown as SupportedFeatureType[],

  getCalibrationApplications: (firmwareId: number | null) =>
    axiosClient.get(GET_CALIBRATION_APPLICATIONS_API, {
      params: { firmwareId }
    }) as unknown as SupportingApplicationsData,

  getProgrammingApplications: (
    firmwareId: string | number | null,
    programmingFileSufi: string | number | null,
    hideObsolete: boolean
  ) =>
    axiosClient.get(GET_PROGRAMMING_APPLICATIONS_API, {
      params: { firmwareId, programmingFileSufi, hideObsolete }
    }) as unknown as SupportingApplicationsData
}
